import React from "react";
import { ddadosRegistrarSolicitacao as DDados } from "../deca.ddados";
import autoBind from "react-autobind";
import BaseComponent, { connect } from "@common/components/base.component";
import decaActions from "../store/deca.actions";
import DecaRegistrarSolicitacaoForm from "./deca.registrarsolicitacao.form";

//Selectors
import atividadeSelectors from "../components/atividades/store/atividade.selectors";
import cnaeSelectors from "../components/cnae/store/cnae.selectors";
import historicoSelectors from "../components/historico/store/historico.selectors";
import socioSelectors from "../components/socio/store/socio.selectors";
import documentoSelector from "../components/documentos/store/documento.selectors";
import camposDinamicosActions from "../components/camposDinamicos/store/camposDinamicos.actions";
import camposDinamicosSelectors from "../components/camposDinamicos/store/camposDinamicos.selectors";
import dadosCadastraisSelector from "../components/dadosCadastrais/store/dadosCadastrais.selectors";
import dadosSolicitanteActions from "../components/dadosSolicitante/store/dadosSolicitante.actions";

class Container extends BaseComponent {
  constructor(props) {
    super(props, DDados);
    autoBind(this);
    this.props.decaActions.setReducerTypeDeca(0);
    this.props.dadosSolicitanteActions.resetFormSolicitante();
  }

  componentDidMount() {
    this.props.camposDinamicosActions.getCamposDinamicos();
  }

  validateString(tipo) {
    return typeof tipo === "string";
  }

  onSubmit(values) {
    const {
      dadosCadastraisSelector,
      atividadeSelectors,
      historicoSelectors,
      cnaeSelectors,
      socioSelectors,
      camposDinamicosSelectors,
      documentoSelector,
    } = this.props;

    //MONTA LISTA DECAATIVIDADE
    values.DecaAtividadeDto = atividadeSelectors.atividade.atividades.map(
      (ativi) => ({
        Id: ativi.Id,
        IdAtividade: ativi.IdAtividade,
        Principal: ativi.Principal ? 1 : 0,
      })
    );

    //MONTA LISTA DECA SOCIO
    values.DecaSocioDto = socioSelectors.socio.listaSocio.map((socio) => ({
      Id: socio.Id,
      CpfCnpj: socio.CpfCnpj,
      Nome: socio.Nome,
      DataEntrada: socio.DataEntrada,
      Email: socio.Email,
      Telefone: socio.Telefone,
      principal: socio.Principal,
      RgIe: socio.RgIe,
      IdCcmSocio: socio.IdCcmSocio,
      EnderecoSocio: socio.EnderecoSocio,
    }));

    //MONTA LISTA DECA HISTORICO
    values.DecaHistoricoDto = historicoSelectors.historico.historicos;

    //MONTA LISTA DECA CNAE
    values.DecaCnaeDto = cnaeSelectors.cnae.cnaes.map((cna) => ({
      Id: cna.Id,
      IdCnae: cna.IdCnae,
      Principal: cna.Principal ? 1 : 0,
      IdDecaSolicitacao: cna.IdDecaSolicitacao,
    }));

    //MONTA LISTA DECA CARACTERISTICA
    values.DecaCaracteristicaDto = [];

    const { arrayCaracteristicas } = camposDinamicosSelectors.camposDinamicos;

    values.DecaCaracteristicaDto = arrayCaracteristicas;

    //MONTA LISTA ANEXOS
    //anexos
    const { anexo, anexoCustomizado } = documentoSelector.documento;

    let DecaAnexoDto = [];

    if (anexo) DecaAnexoDto = [...anexo];
    if (anexoCustomizado) DecaAnexoDto = [...DecaAnexoDto, ...anexoCustomizado];

    values.DecaAnexoDto = DecaAnexoDto;

    this.props.decaActions.save({
      //DADOS SOLICITACAO
      CpfCnpjSolicitacao: values.CpfCnpjSolicitacao,
      TipoSolicitacao: values.TipoSolicitacao,
      CCMSolicitacao: values.CCM,
      SituacaoSolicitacao: values.SituacaoSolicitacao,
      DescricaoSolicitacao: values.DescricaoSolicitacao,

      //DADOS SOLICITANTE
      CpfCnpjSolicitante: values.CpfCnpjSolicitante,
      NomeSolicitante: values.NomeSolicitante,
      EmailSolicitante: values.EmailSolicitante,
      TelefoneSolicitante: values.TelefoneSolicitante,
      CelularSolicitante: values.CelularSolicitante,
      RgIeSolicitante: values.RgIeSolicitante,
      CelularSolicitante: values.CelularSolicitante,

      // END DADOS SOLICITANTE
      DecaEnderecoSolicitante: {
        ...values.EnderecoSolicitante,
        IdDecaSolicitacao: values.Id,
      },

      //DADOS CADASTRAIS
      NomeEmpresa: values.NomeCadastral,
      NomeFantasiaEmpresa: values.NomeFantasiaCadastral,
      EmailEmpresa: values.EmailCadastral,
      TelefoneEmpresa: values.TelefoneCadastral,
      CelularEmpresa: values.CelularCadastral,
      DataNascimento: values.DataNascimentoCadastral,
      RgIeEmpresa: values.RgIeCadastral,
      DataAbertura: values.DataAberturaCadastral,
      DataOcorrencia: values.DataOcorrencia,
      IdContador: values.Contador ? values.Contador.Id : undefined,
      Contador: values.Contador ? values.Contador.Exibicao : undefined,
      EmailContador: values.EmailContadorCadastral,
      RegimeTributacao: values.RegimeTributacaoCadastral
        ? values.RegimeTributacaoCadastral
        : dadosCadastraisSelector.dadosCadastrais.RegimeTributacaoCadastral,
      DescricaoAtividade: values.DescricaoAtividade,
      IdGrupo: values.IdGrupo,

      //DADOS DINAMICOS

      //ENDERECO PRINCIPAL
      DecaEnderecoPrincipal: {
        ...values.EnderecoPrincipal,
        IdDecaSolicitacao: values.Id,
      },

      // ENDERECO COBRANCA
      DecaEnderecoCobranca: {
        ...values.EnderecoCobranca,
        IdDecaSolicitacao: values.Id,
      },

      // LISTA CNAE
      DecaCnaeDto: values.DecaCnaeDto,

      // LISTA HISTORICO
      DecaHistoricoDto: values.DecaHistoricoDto,

      // LISTA SOCIO
      DecaSocioDto: values.DecaSocioDto,

      // LISTA ATIVIDADE
      DecaAtividadeDto: values.DecaAtividadeDto,

      //LISTA CARACTERISTICA

      DecaSolicitacaoCaracteristicaDto: values.DecaCaracteristicaDto,

      //LISTA ANEXO

      DecaAnexoDto: values.DecaAnexoDto,

      //LISTA FILE ANEXO

      DecaFileAnexoDto: values.DecaFileAnexoDto,
    });
  }

  render() {
    return <DecaRegistrarSolicitacaoForm onSubmit={this.onSubmit} />;
  }
}

export default connect({
  actions: {
    decaActions,
    dadosSolicitanteActions,
    camposDinamicosActions,
  },
  selectors: {
    dadosCadastraisSelector,
    atividadeSelectors,
    cnaeSelectors,
    historicoSelectors,
    camposDinamicosSelectors,
    documentoSelector,
    socioSelectors,
  },
})(Container);
